<template>
  <div class="post type-post hentry">
    <h2>
      <router-link to="/2012/01/vaiku-islaikymas/"
        >Vaikų išlaikymas</router-link
      >
    </h2>
    <div class="comm_date">
      <span class="month">Sausio</span><span class="date_nr">23</span>
    </div>
    <div class="entry">
      <p>
        <strong>Kiek alimentų vaikui privalo mokėti nedirbantis asmuo?</strong>
      </p>
      <p>
        LR CK 3.192 str. 1 d. numatyta, jog tėvai privalo materialiai išlaikyti
        savo nepilnamečius vaikus.
      </p>
      <p>
        CK 3.192 str. 2 d. numatyta, kad išlaikymo dydis turi būti proporcingas
        nepilnamečių vaikų poreikiams bei jų tėvų turtinei padėčiai ir
        užtikrinti būtinas vaikui vystytis sąlygas, o 3 d. numatyta, jog
        išlaikymą nepilnamečiams vaikams privalo teikti abu tėvai proporcingai
        savo turtinei padėčiai.
      </p>
      <p>
        Jokios minimalios sumos ar maksimalių dydžių, įstatymai nenumato. Tačiau
        teismų praktikoje susiformavo optimalūs dydžiai. LR Aukščiausiojo teismo
        Senatas, įvertinęs keleto metų teismų sprendimus, mano, kad vienam
        vaikui išlaikyti vidutiniškai reikia apie 700-800 Lt. Kadangi abu tėvai
        vienodai atsakingi už savo vaikų išlaikymą ir auklėjimą, todėl iš
        kiekvieno priteistina, vidutiniškai, po 350-400 Lt. Nukrypimai į didesnę
        ar mažesnę pusę galimi tik esant rimtoms priežastims – pakitusiems vaiko
        poreikiams arba tėvų turtinei padėčiai.
      </p>
      <p>
        CK 3.194 str. 1 d. numatyta, jeigu nepilnamečio vaiko tėvai (ar vienas
        iš jų) nevykdo pareigos materialiai išlaikyti savo nepilnamečius
        vaikus,&nbsp; teismas išlaikymą priteisia pagal vieno iš tėvų ar vaiko
        globėjo (rūpintojo) arba valstybinės vaiko teisių apsaugos institucijos
        ieškinį. Šio str. 3 d. sako, jog išlaikymą teismas priteisia iki vaikui
        sueis pilnametystė, išskyrus atvejus, kai vaikas yra nedarbingas dėl
        invalidumo, kuris nustatytas esant nepilnamečiui.
      </p>
      <p>
        Pagal LR CPK 742 str. 4 p., jeigu asmuo, privaląs mokėti vaikams
        išlaikyti periodines išmokas, šių išmokų nemoka ir nedirba arba
        išlaikymo įsiskolinimo negalima išieškoti CPK 663 str. 1 d. nustatyta
        tvarka, išieškojimas nukreipiamas į skolininko turtą. Nesant turto,
        skola kaupiasi, kurią vaikas gali išsiieškoti net ir sulaukęs
        pilnametystės. Bendroji senatis ilga – 10 metų. Piktybinis vengimas
        teikti išlaikymą yra baudžiamas pagal LR BK 164 str. (tas, kas vengė
        pareigos pagal teismo sprendimą išlaikyti vaiką, mokėti lėšas vaikui
        išlaikyti ar teikti kitą būtiną materialią paramą vaikui, baudžiamas
        viešaisiais darbais arba laisvės apribojimu, arba areštu, arba laisvės
        atėmimu iki dvejų metų). Dėl ikiteisminio tyrimo atlikimo reikėtų
        kreiptis į policiją su pareiškimu arba į antstolį, kuris vykdomąjį
        dokumentą perduos kompetentingai ikiteisminio tyrimo institucijai.
      </p>
      <p>
        Pravartu nesąžiningiems tėveliams (ar mamytėms) žinoti, kad vengęs
        išlaikyti vaiką asmuo praranda teisę būti to vaiko išlaikomas senatvės
        ar negalios atveju.
      </p>
      <p>
        Be to, vaiko motina gali gauti išlaikymą iš valstybės, kurio suma
        paverčiama nesąžiningo tėvelio (ar mamytės) skola valstybei, su visomis
        tos skolos palūkanomis ir išieškojimo kaštų susigrąžinimu iš skolininko.
        Ir senatis ilga – 10 metų nuo skolos fakto paaiškėjimo.
      </p>
    </div>
  </div>
</template>
